import React, { useState } from 'react';

import Webcam from 'react-webcam';
import IconButton from '@material-ui/core/IconButton';

import CameraIcon from '@material-ui/icons/PhotoCamera';

export default function Camera(props) {    
    const [webcamRef, setWebcamRef] = useState(null);    

    const webcamStyle = {
        // The video will fill the entire container div
        width: '600px',
        height: '600px',                
        objectFit:'cover',
        padding:'20px'
    };
    
    const videoConstraints = {
        width:600,
        height:600,
        facingMode: 'user',        
    };

    return (        
        <div style={{width:'600px', height:'900px'}}>
            <Webcam
                style={webcamStyle}            
                videoConstraints={videoConstraints}      
                mirrored={true}
                screenshotFormat='image/jpeg'
                ref={e => setWebcamRef(e)}
            />
            <div style={{textAlign:'center'}}>
                <IconButton style={{background:'white'}} onClick={_ => props.onClick(webcamRef.getScreenshot())}>
                    <CameraIcon fontSize='large'/>    
                </IconButton>
            </div>            
        </div>
        
    )
}
